module.exports = __webpack_public_path__ + "static/img/ic_bd.b3d7b3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/ic_bd.png
// module id = MR0/
// module chunks = 0